import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { Widget } from 'src/dashboard/Componets/Widget';
import { useTariffAccountRef } from './../hooks/useTariffAccountRef';
import { SubscriptionStatusChart } from './SubscriptionStatusChart';
import { Suspense } from 'react';
import { DoughnutChartCardSkeleton } from 'src/common/components/Graphs/common/Graphs/components/DoughnutChartCardSkeleton';
import { DoughnutSelectUserCard } from 'src/common/components/Graphs/common/Graphs/components/DoughnutSelectUserCard';
import { UsageChartWidget } from './UsageChartWidget';
import { useSelectedTariff } from '../hooks/useSelectedTariff';
import { AreaChartSkeleton } from 'src/common/components/Graphs/common/Graphs/components/AreaChartSkeleton';

import {
  GridLayout,
  GridLayoutItem,
  GridLayoutWideItem,
} from 'src/common/components/Layouts/GridLayout/GridLayout';
import { DoughnutWidgetErrorBoundary } from 'src/dashboard/Componets/DoughnutWidgetErrorBoundary';

const AreaChartSkeletonContainer = styled(Box)(({ theme }) => ({
  height: `calc(100% - ${theme.spacing(20)})`,
}));

export const TariffSummaryGraphs = () => {
  const { t } = useTranslation();

  const accountRef = useTariffAccountRef();
  const { selectedTariffId } = useSelectedTariff();

  return (
    <GridLayout>
      <GridLayoutItem key="subscriptionStatus" data-testid="subscriptionsStatus">
        <DoughnutWidgetErrorBoundary
          title={t('dashboard.subscriptionsStatusChart.title')}
          key={accountRef}
        >
          <Widget title={t('dashboard.subscriptionsStatusChart.title')}>
            <Suspense fallback={<DoughnutChartCardSkeleton />}>
              {accountRef ? (
                <SubscriptionStatusChart accountRef={accountRef} tariffCode={selectedTariffId} />
              ) : (
                <DoughnutSelectUserCard />
              )}
            </Suspense>
          </Widget>
        </DoughnutWidgetErrorBoundary>
      </GridLayoutItem>
      <GridLayoutWideItem key="cumulativeUsage" data-testid="cumulativeUsage">
        <Suspense
          fallback={
            <Widget title={t('dashboard.cumulativeUsageChart.title')}>
              <AreaChartSkeletonContainer>
                <AreaChartSkeleton />
              </AreaChartSkeletonContainer>
            </Widget>
          }
        >
          <UsageChartWidget accountRef={accountRef} tariffCode={selectedTariffId} />
        </Suspense>
      </GridLayoutWideItem>
    </GridLayout>
  );
};
